module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C1613"
  }, [_c('span', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("It’s ")]), _vm._v("Hard to Know Where to Begin")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("I could start under a tree outside")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("my grandmother’s kitchen window,")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("or I could wait until the dog needs")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("a walk, or I could start over here")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("by the couch and stack of books.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("Maybe not; maybe upstairs under")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("the bed or even in the basement,")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("back behind that pile of toys we")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("keep saying we’ll give away.")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("The garden is a possibility,")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("around the comfrey or the spent")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("peonies. Or maybe just here,")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("where an old man from when")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("I was a kid came up and asked")]), _vm._v(" "), _c('p', {
    staticClass: "C1600"
  }, [_vm._v("if I would look at his hands.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edc2be5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/09_It_s_Har.vue
// module id = 81
// module chunks = 0